var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"job-role-search"},[_c('BnDropdown',{attrs:{"label":"Search Job Role","modelValue":_vm.selectedValue,"options":_vm.filteredItems,"searchable":"","code":"","external":"","loading":_vm.loading},on:{"update:modelValue":(v) => { _vm.selectedValue = v; },"search":_vm.onSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }